import { createSlice } from "@reduxjs/toolkit";

// Slice to store the list of roles within a project
const roleDataSlice = createSlice({
  name: "roleData",
  initialState: [],
  reducers: {
    setProjectRolesList: (_state, action) => action.payload,
  },
});
export const { setProjectRolesList } = roleDataSlice.actions;
export const roleData: any = roleDataSlice.reducer;

// Slice to store list of users inside spaces
const spacesUsersDataSlice = createSlice({
  name: "spacesUsersData",
  initialState: [],
  reducers: {
    setSpacesInProjectList: (_state, action) => action.payload,
  },
});
export const { setSpacesInProjectList } = spacesUsersDataSlice.actions;
export const spacesUsersData: any = spacesUsersDataSlice.reducer;

// Slice to store project entities list
const entityListSlice = createSlice({
  name: "entityList",
  initialState: [],
  reducers: {
    setEntityList: (_state, action) => action.payload,
  },
});
export const { setEntityList: setEntityListAction } = entityListSlice.actions;
export const setEntityList: any = entityListSlice.reducer;

// Slice to store status list
const statusDataSlice = createSlice({
  name: "statusData",
  initialState: [],
  reducers: {
    setStatusData: (_state, action) => action.payload,
  },
});
export const { setStatusData } = statusDataSlice.actions;
export const statusData: any = statusDataSlice.reducer;

// Slice to store category list
const categoryListSlice = createSlice({
  name: "categoryList",
  initialState: [],
  reducers: {
    setCategoryList: (_state, action) => action.payload,
  },
});
export const { setCategoryList: setCategoryListAction } = categoryListSlice.actions;
export const setCategoryList: any = categoryListSlice.reducer;

// Slice for deleted space status
const deleteSpaceSlice = createSlice({
  name: "deleteSpace",
  initialState: [],
  reducers: {
    deletedSpaceStatus: (_state, action) => action.payload,
  },
});
export const { deletedSpaceStatus } = deleteSpaceSlice.actions;
export const deleteSpace: any = deleteSpaceSlice.reducer;

// Slice for deleted user status
const deletedUserSlice = createSlice({
  name: "DeletedUserState",
  initialState: [],
  reducers: {
    deletedUserStatus: (_state, action) => action.payload,
  },
});
export const { deletedUserStatus } = deletedUserSlice.actions;
export const DeletedUserState: any = deletedUserSlice.reducer;

// Slice for project setting object
const projectSettingObjectSlice = createSlice({
  name: "getProjectSettingObject",
  initialState: {},
  reducers: {
    getProjectSettingObject: (_state, action) => action.payload,
  },
});

const projectSideBarIconAndNameMapper = createSlice({
  name: "projectSideBarIconsAndNameMapper",
  initialState: [],
  reducers: {
    setProjectSideBarIconsAndNameMapper: (_state, action) => action.payload,
  },
});
export const { setProjectSideBarIconsAndNameMapper } = projectSideBarIconAndNameMapper.actions;
export const projectSideBarIconAndNameMapperReducer: any = projectSideBarIconAndNameMapper.reducer;
export const { getProjectSettingObject: getProjectSettingObjectAction } = projectSettingObjectSlice.actions;
export const getProjectSettingObject: any = projectSettingObjectSlice.reducer;
